import calls from '@/backend/api-calls'

const state = () => ({
  boms: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
    project_id: null
  }
})

// getters
const getters = {
  bomIds: state => {
    return state.boms.map(d => d.id);
  }
}

// actions
const actions = {
  getBoms: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.boms.get(parameters)
        .then(resp => {
          commit("setBoms", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addBom({commit}, { data, parameters }) {
    return new Promise((resolve, reject) => {
      calls.boms.post(data, parameters)
        .then(resp => {
          commit("insertBom", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateBom: ({commit}, { bomId, data }) => {
    return new Promise((resolve, reject) => {
      calls.bom.put(bomId, data).then(
        resp => {
          commit("insertUpdatedBom", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Bom successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteBom: ({commit}, bomId) => {
    return new Promise((resolve, reject) => {
      calls.bom.delete(bomId).then(
        resp => {
          commit("removeBom", bomId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'BOM successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addDetail: ({commit}, detail) => {
    return new Promise((resolve, reject) => {
      calls.bomDetails.post(detail).then(
        resp => {
          commit("insertBomDetail", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addSlabItem: ({commit}, item) => {
    return new Promise((resolve, reject) => {
      calls.bomDetails.addSlab(item).then(
        resp => {
          resp.data.forEach(item => {
            commit("insertBomDetail", item);
          })
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.bomIds);
    } else {
      commit("deselectAll");
    }
  }
  // removeDetail: ({commit}, detailId) => {
  //   return new Promise((resolve, reject) => {
  //     calls.bomDetail.delete(detailId).then(
  //       resp => {
  //         commit("removeBomDetail", detailId);
  //         resolve(resp);
  //       }
  //     ).catch(err => reject(err));
  //   })
  // },
  // updateDetail: ({commit}, { detailId, data }) => {
  //   return new Promise((resolve, reject) => {
  //     calls.bomDetail.put(detailId, data).then(
  //       resp => {
  //         commit("insertUpdatedBomDetail", resp.data);
  //         resolve(resp);
  //       }
  //     ).catch(err => reject(err));
  //   })
  // }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setBoms(state, data) {
    state.pagination = data.pagination;
    state.boms = data.results;
  },
  insertBom(state, data) {
    state.boms.push(data);
  },
  insertUpdatedBom(state, data) {
    state.boms.forEach((bom, i) => {
      if (bom.id == data.id) {
        state.boms.splice(i, 1, data);
      }
    })
  },
  removeBom(state, bomId) {
    state.boms.forEach((bom, i) => {
      if (bom.id == bomId) {
        state.boms.splice(i, 1);
      }
      const index = state.selected.indexOf(bomId);
      if (index != -1) {
        state.selected.splice(index, 1);
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  insertBomDetail(state, bomDetail) {
    if (bomDetail) {
      state.boms.forEach(bom => {
        if (bom.id == bomDetail.bom_id) {
          bom.details.push(bomDetail);
        }
      })
    }
  },
  selectAll(state, bomIds) {
    state.allSelected = true;
    bomIds.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  },
  setFilter(state, { field, value }) {
    state.filters[field] = value;
  }
  // removeBomDetail(state, detailId) {
  //   state.boms.forEach(bom => {
  //     if (bom.id == bomId) {
  //       bom.details.forEach((detail, i) => {
  //         if (detail.id == detailId) {
  //           bom.details.splice(i, 1);
  //         }
  //       })
  //     }
  //   })
  // },
  // insertUpdatedBomDetail(state, bomDetail) {
  //   state.boms.forEach(bom => {
  //     if (bom.id == bomDetail.bom_id) {
  //       bom.details.forEach((detail, i) => {
  //         if (detail.id == bomDetail.id) {
  //           bom.details.splice(i, 1, bomDetail);
  //         }
  //       })
  //     }
  //   })
  // }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}